export default "__VITE_ASSET__bd100c34__"